<h2>{{formLabels['title']}} {{form1.value.name}}</h2>
<form [formGroup]="form1">
  <mat-tab-group>
    <mat-tab label="Message Template">
      <div class="container-fluid">
        <div class="row m-0">
          <div class="col-lg-6 col-md-6">
            <mat-card class="my-3">
              <div class="row">
                <div class="col-lg-12">
                  <mat-card-header>
                    <mat-card-title>Message Template</mat-card-title>
                  </mat-card-header>
                </div>
                <div class="col-lg-12">
                  <mat-card-content class="row">
                    <div class="col-lg-12">
                      @if (('form1.value.messageTemplateId')) {
                        <mat-form-field class="block">
                          <input
                            matInput
                            placeholder="MessageTemplateId"
                            [value]="form1.value.messageTemplateId"
                            readonly="true">
                          </mat-form-field>
                        }
                      </div>
                      <div class="col-lg-12">
                        @if (('form1.value.lastUpdate')) {
                          <mat-form-field class="block">
                            <input
                              matInput
                              placeholder="Updated"
                              [value]="form1.value.lastUpdate"
                              readonly="true">
                            </mat-form-field>
                          }
                        </div>
                        <div class="col-lg-12">
                          @if (('form1.value.createDate')) {
                            <mat-form-field class="block">
                              <input
                                matInput
                                placeholder="Created"
                                [value]="form1.value.createDate"
                                readonly="true">
                              </mat-form-field>
                            }
                          </div>
                          <div class="col-lg-12">
                            <mat-form-field class="block">
                              <input
                                matInput
                                placeholder="name"
                                formControlName="name"
                                readonly="{{formReadOnly}}">
                                @for (validation of validationMessages.name; track validation) {
                                  <mat-error>
                                    @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                                      <mat-error
                                        class="error-message"
                                      > {{validation.message}}</mat-error>
                                    }
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-lg-12">
                              <mat-form-field class="block">
                                <input
                                  matInput
                                  placeholder="description"
                                  formControlName="description"
                                  readonly="{{formReadOnly}}">
                                  @for (validation of validationMessages.description; track validation) {
                                    <mat-error>
                                      @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                                        <mat-error
                                          class="error-message"
                                        > {{validation.message}}</mat-error>
                                      }
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-lg-12">
                                <mat-form-field class="block">
                                  <input
                                    matInput
                                    placeholder="subject"
                                    formControlName="subject"
                                    readonly="{{formReadOnly}}">
                                    @for (validation of validationMessages.subject; track validation) {
                                      <mat-error>
                                        @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                                          <mat-error
                                            class="error-message"
                                          > {{validation.message}}</mat-error>
                                        }
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-lg-12">
                                  <mat-form-field class="block">
                                    <textarea
                                      matInput
                                      placeholder="Message"
                                      formControlName="message"
                                      readonly="{{formReadOnly}}"
                                      matTextareaAutosize
                                      matAutosizeMinRows=10
                                    matAutosizeMaxRows=500></textarea>
                                    @for (validation of validationMessages.message; track validation) {
                                      <mat-error>
                                        @if (form1.get('message').hasError(validation.type) && (form1.get('message').dirty || form1.get('message').touched)) {
                                          <mat-error
                                            class="error-message"
                                          > {{validation.message}}</mat-error>
                                        }
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                              </mat-card-content>
                            </div>
                          </div>
                        </mat-card>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <mat-card class="my-3">
                          <div class="row">
                            <div class="col-lg-12">
                              <mat-card-header>
                                <mat-card-title>Variables</mat-card-title>
                              </mat-card-header>
                            </div>
                            <div class="col-lg-12">
                              <mat-card-content> checkin_date<br>
                                checkout_date<br>
                                guest_first_name<br>
                                guest_last_name<br>
                                resort_name<br>
                                building_name(ie: Konea)<br>
                                unit_name (ie: HKH-236)<br>
                                unit_number (ie: 236)<br>
                                rental_car_summary<br>
                                front_door_code<br>
                                garage_door_code<br>
                                driveway_gate_code<br>
                                pool_code<br>
                              </mat-card-content>
                            </div>
                          </div>
                        </mat-card>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="History">
                  <app-audit-list [auditUrl]="'message-templates/' + this.messageTemplateId + '/audit'"></app-audit-list>
                </mat-tab>
              </mat-tab-group>
              <div class="container-fluid">
                <mat-card-actions class="row">
                  <div class="col-lg-12">
                    @if (formAction.includes('add')) {
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="formAdd()"
                      [disabled]="!form1.valid">Add</button>
                    }
                    @if (formAction.includes('add')) {
                      <button
                        mat-button
                        type="reset"
                      (click)="this.form1.reset()">Clear</button>
                    }
                    @if (formAction.includes('add')) {
                      <button
                        mat-button
                        type="button"
                      (click)="routerLocation.back()">Cancel</button>
                    }
                    @if (formAction.includes('edit')) {
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="formUpdate()"
                      [disabled]="!form1.valid">Update</button>
                    }
                    @if (formAction.includes('edit')) {
                      <button
                        mat-button
                        type="button"
                      [routerLink]="['/message-template-view', form1.value.messageTemplateId]">Cancel</button>
                    }
                    @if (formAction.includes('view')) {
                      <button
                        mat-raised-button
                        color="primary"
                      [routerLink]="['/message-template-edit', form1.value.messageTemplateId]">Edit</button>
                    }
                    @if (formAction.includes('view')) {
                      <button
                        mat-button
                        type="button"
                      [routerLink]="['/message-template-list']">Done</button>
                    }
                    @if (formLoading) {
                      <img
                        class="pl-3"
				src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
			</div>
		</mat-card-actions>
	</div>
</form>